/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components

import axios from "axios";

//Backend access
import React from 'react';

import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Route, Link, Routes, useLocation, useNavigate, useMatch } from 'react-router-dom';

// Images
import iconSunCloud from "assets/images/small-logos/icon-sun-cloud.png";
import WeatherCard from "examples/Cards/WeatherCard";
import PropTypes from "prop-types";
import { loadToken, getWeather } from 'api/weather';

import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

// Setting default values for the props of GradientMinMaxLineChart
function WeatherProvider({ position = { latitude: 33.8688, longitude: 151.2093 }, icon_width }) {
  loadToken(useAuth0());

  const { latitude, longitude } = position; // default is sydney
  const default_icon = { component: iconSunCloud, text: "cloudy" };

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ['getWeather', latitude, longitude],
    queryFn: async () => {
      const data = await getWeather(latitude, longitude);
      return data;
    },
    staleTime: 20 * 1000
  });

  if (isLoading) {
    return (
      <WeatherCard
        color={color}
        title="weather today"
        weather={{ location: "", degree: 12 }}
        icon={{ component: iconSunCloud, text: "cloudy" }}
        icon_width={icon_width}
      />)
  }

  if (error) {
    return (
      <WeatherCard
        color={color}
        title="weather today"
        weather={{ location: "Sydney", degree: 12 }}
        icon={{ component: iconSunCloud, text: "cloudy" }}
        icon_width={icon_width}
      />)
  }

  if (isFetching) {
    return (
      <WeatherCard
        color={color}
        title="weather today"
        weather={{ location: "Sydney", degree: 12 }}
        icon={{ component: iconSunCloud, text: "cloudy" }}
        icon_width={icon_width}
      />)
  }

  // console.log(data);

  switch (data.weather[0].icon) {
    case '01d':
    case '01n':
    case '02d':
    case '02n':
    case '10d':
    case '10n':
    case '50d':
    case '50n':
      var color = 'info';
      break;
    case '03d':
    case '03n':
    case '04d':
    case '04n':
    case '09d':
    case '09n':
    case '11d':
    case '11n':
      var color = 'secondary';
      break;
    case '13d':
    case '13n':
      var color = 'light';
      break;
    default:
      var color = 'info';
      break;
  }

  return (
    <WeatherCard
      color={color}
      title="weather today"
      weather={{ location: data.name, degree: Math.round(data.main.temp, 1) }}
      icon={{ component: require('assets/images/openweathermap/' + data.weather[0].icon + '_t@4x.png'), text: data.weather[0].main }}
      icon_width={icon_width}
    />)

}

// Typechecking props for the GradientMinMaxLineChart
WeatherProvider.propTypes = {
  position: PropTypes.object,
  backgroundColour: PropTypes.string,
  icon_width: PropTypes.string,
};


export default WeatherProvider;
